export default {"src":"/_next/static/media/v10.8c0d4321.svg","height":130,"width":332};